import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./AutoCompleteInput.module.scss";

type Props = {
  handler: (value: string) => boolean;

  label: string;
  name: string;
  options: Array<string>;
  value?: string;
  placeholder?: string;
  id: string;
  inputClass?: string;
  labelClass?: string;
};

const AutocompleteInput: React.FC<Props> = ({
  handler,
  label,
  name,
  options,
  value,
  placeholder,
  id,
  inputClass,
  labelClass,
}) => {
  const { t } = useTranslation();

  function genDatalist() {
    const opts = options.map((val: string, i: number) => (
      <option value={val} key={i}>
        {t(val)}
      </option>
    ));

    return <datalist id={`${id}-list`}>{opts}</datalist>;
  }

  async function verifyInput(event: React.ChangeEvent<HTMLInputElement>) {
    const val = event.target.value;
    const reset = handler(val);

    if (reset) {
      event.target.value = "";
    }
  }

  return (
    <>
      <div className={styles["c-auto-complete-input__box"]}>
        <label className={labelClass} htmlFor={id}>
          {t(label)}
        </label>
        <input
          className={inputClass}
          type="text"
          id={id}
          name={name}
          value={value}
          onChange={verifyInput}
          placeholder={placeholder}
          list={`${id}-list`}
          autoComplete="off"
        />
        <FontAwesomeIcon icon={["fal", "chevron-down"]} />
      </div>
      {genDatalist()}
    </>
  );
};

export default AutocompleteInput;
